import { useNavigate } from 'react-router-dom'

import { Box, Section } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { usePayrollBundleSettings } from 'modules/payroll_bundle/hooks/usePayrollBundleSettings'

import Item from './Item'

const Content = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { isConnectedExpensesMappingsVisible } = usePayrollBundleSettings()

  const navigateToManageCategoriesAndTitle = () => {
    navigate(navigation.settings.payroll_bundle.expensesReimbursement.path)

    track(trackingEvents.payroll.gotoManageCategoriesAndTitle)
  }

  const navigateToTimeCategoriesSupplements = () => {
    navigate(navigation.settings.payroll_bundle.timeReimbursement.path)
    // TODO: check if we need to track any event
  }

  return (
    <Box
      component="ul"
      borderRadius={{ all: 'abs016' }}
      background="grey000White"
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
    >
      {isConnectedExpensesMappingsVisible && (
        <Item
          onClick={navigateToManageCategoriesAndTitle}
          title={i18n.t(
            'app_store_v2.apps.payroll_bundle.settings.external_supplements.expenses_reimbursement'
          )}
        />
      )}
      <Item
        onClick={navigateToTimeCategoriesSupplements}
        title={i18n.t(
          'app_store_v2.apps.payroll_bundle.settings.external_supplements.time_categories'
        )}
      />
    </Box>
  )
}

const ConnectedSupplements = () => {
  return (
    <Section
      title={i18n.t(
        'app_store_v2.apps.payroll_bundle.settings.external_supplements.new_settings_title'
      )}
      illustration={'money-bag'}
      description={i18n.t(
        'app_store_v2.apps.payroll_bundle.settings.external_supplements.new_settings_description'
      )}
    >
      <Content />
    </Section>
  )
}

export default ConnectedSupplements
